module.exports = __webpack_public_path__ + "img/image_9.2dd76618.jpg";